import { useCallback } from 'react';
import gettext, { ngettext } from '@sdk/lang/gettext';
import ConfirmModal from '@sdk/components/ui/confirmModal/ConfirmModal';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';

import ExclamationMarkIcon from '@web/assets/svg/UI/exclamation-mark.svg';
import { useDeleteMultipleAnnouncements } from '@web/announcements/hooks/useDeleteMultipleAnnouncements';

import { Description, IconWrapper } from './deleteMultipleAnnouncementsConfirm.styles';

type Props = {
  ids: number[];
  onClose: () => void;
  onDelete: (failedIds?: number[]) => void;
};

export const DeleteMultipleAnnouncementsConfirm = ({ ids, onClose, onDelete }: Props) => {
  const { mutateAsync } = useDeleteMultipleAnnouncements();

  const handleAction = useCallback(() => {
    onDelete();

    return mutateAsync(ids, {
      onSuccess: ({ failedIds }) => {
        if (failedIds.length) {
          onDelete(failedIds);
        }
        onClose();
      },
    });
  }, [ids, onClose, onDelete, mutateAsync]);

  return (
    <ConfirmModal
      buttonsPadding={0}
      dismissOnBackdropClick={false}
      fullScreen
      titleText={gettext('Please confirm')}
      titleThemeColor={ThemeColorType.danger}
      titleIcon={
        <IconWrapper>
          <ExclamationMarkIcon aria-hidden={true} />
        </IconWrapper>
      }
      primaryButtonText={gettext('Delete')}
      primaryButtonType={ButtonType.danger}
      dismiss={onClose}
      onPrimaryClick={handleAction}
      zIndex={1045}>
      <Description>
        {ngettext(
          'Are you sure you want to delete selected announcement?',
          'Are you sure you want to delete selected announcements?',
          ids.length
        )}
      </Description>
    </ConfirmModal>
  );
};
